import { useEffect, useState } from "react";
import { MISSIONS } from "@/data/content";
import { fetchMissions } from "@/lib/api";
import PageHero from "@/components/arc/PageHero";
import Reveal from "@/components/arc/Reveal";
import { HudRow, Panel, SimTag, StatusBadge } from "@/components/arc/ui";
import { GlowOrbs } from "@/components/arc/Backdrops";

const Missions = () => {
  const [missions, setMissions] = useState(MISSIONS);
  const [source, setSource] = useState("local");

  useEffect(() => {
    fetchMissions().then((data) => {
      setMissions(data);
      setSource("api");
    });
  }, []);

  return (
    <>
      <PageHero
        index="05"
        eyebrow="MISSIONS"
        title="MISSION CONTROL"
        sub="The objective board of the machine. Every mission shown here is fictional and simulated — a demonstration of the mission framework, not live on-chain activity."
      />
      <section className="relative overflow-hidden pb-24 md:pb-36">
        <GlowOrbs />
        <div className="relative mx-auto max-w-[1600px] px-5 md:px-8">
          <Reveal>
            <div className="mb-10 flex flex-wrap items-center gap-4">
              <SimTag>SIMULATED MISSIONS</SimTag>
              <span className="hud-label" data-testid="missions-source">
                SOURCE {"//"} {source === "api" ? "ARCIMUS CONTENT API" : "LOCAL CACHE"}
              </span>
            </div>
          </Reveal>
          <div className="grid gap-5 lg:grid-cols-2" data-testid="missions-grid">
            {missions.map((m, i) => (
              <Reveal key={m.id} delay={i * 0.08}>
                <Panel
                  className={`h-full p-7 transition-shadow duration-300 md:p-8 ${
                    m.status === "ACTIVE" ? "hover:shadow-[0_0_44px_rgba(0,168,255,0.3)]" : "hover:shadow-[0_0_30px_rgba(22,119,255,0.18)]"
                  }`}
                  data-testid={`mission-card-${m.id}`}
                >
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <span className="font-term text-[11px] tracking-[0.34em] text-silver">{m.code}</span>
                    <StatusBadge status={m.status} />
                  </div>
                  <h2 className="mt-4 font-display text-xl font-bold tracking-[0.14em] text-chrome md:text-2xl">
                    {m.name}
                  </h2>
                  <div className="mt-6 space-y-1">
                    <div className="py-3">
                      <p className="hud-label">OBJECTIVE</p>
                      <p className="mt-2 text-sm leading-relaxed text-silver md:text-base">{m.objective}</p>
                    </div>
                    <HudRow label="REWARD" value={m.reward} accent />
                    <div className="flex items-center justify-between border-b border-ice/10 py-3">
                      <span className="hud-label">DIFFICULTY</span>
                      <span className="font-term text-xs tracking-[0.24em] text-electric" aria-label={`Difficulty ${m.difficulty} of 5`}>
                        {"▮".repeat(m.difficulty)}{"▯".repeat(5 - m.difficulty)}
                      </span>
                    </div>
                    <HudRow label="VERIFICATION" value={m.verification} />
                  </div>
                </Panel>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <p className="mt-12 max-w-3xl font-term text-[10px] leading-relaxed tracking-[0.2em] text-silver/60">
              VERIFICATION LABELS — SELF-DIAGNOSTIC, SIMULATION, PLANNED, CONCEPT, VISION —
              DESCRIBE HOW REAL EACH MISSION IS. NONE OF THESE MISSIONS EXECUTE ON A BLOCKCHAIN
              TODAY.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default Missions;
